export default {"src":"/_next/static/media/charles-schwab-logo.cb74bef1.svg","height":27,"width":186};